import { MessageToMerchant } from "../remoteAction";

export type ElementShiftClickedAction = MessageToMerchant<
  "ELEMENT_SHIFT_CLICKED",
  string
>;
export type ElementClickedAction = MessageToMerchant<"ELEMENT_CLICKED", string>;

export type sendElementClickedAction =
  | ElementShiftClickedAction
  | ElementClickedAction;

export function sendElementClicked(
  event: React.FormEvent<HTMLElement>,
  configName: string
): sendElementClickedAction | null {
  event.stopPropagation();

  // tslint:disable-next-line
  if ((event as any).shiftKey) {
    return {
      type: "SEND_MESSAGE_TO_MERCHANT",
      payload: {
        type: "ELEMENT_SHIFT_CLICKED",
        data: configName,
      },
    };
  }

  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "ELEMENT_CLICKED",
      data: configName,
    },
  };
}
